import { http } from "../http-common";

const getRulesList = () => {
  return http.get(`/conflict-indicator`);
};

const updateRules = (payload) => {
  return http.put(`/conflict-indicator`, payload);
};

const createRule = (payload) => {
    return http.post(`/conflict-indicator`, payload);
  };

const getRuleModules = () => {
    return http.get(`/role-functionality-management/track-wise-functionalities`);
  };
  

const getActiveRoles = () => {
  return http.get(`/role-management/getActiveRoles`);
};
const getUserCreation = () => {
  return http.get(`/user-management`);
};

const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateUserManagement = (data) => {
  return http.put(`/user-management`, data);
};

const createUserManagement = (data) => {
  return http.post(`/user-management`, data);
};

const deleteManure = ({ id }) => {
  return http.delete(`/greenManure/${id}`);
};

// const searchCuringUnitName = ({
//   tobaccoGroup,
//   status,
//   isNew,
//   countryCode,
//   curingUnitName,
//   page,
//   size,
// }) => {
//   const params = {
//     tobaccoGroup,
//     status,
//     isNew,
//     countryCode,
//     curingUnitName,
//     pageNumber: page,
//     pageSize: size,
//   };
//   const filteredEntries = Object.entries(params).filter(([key, value]) => value != "");
//   let newParams = Object.fromEntries(filteredEntries);
//   newParams['pageNumber'] = params.pageNumber
//   return http.get('/curingunit/search', { params: newParams });
// };

const searchManureData = (keyword) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`
  );
};

const searchManureDataFull = () => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=50`);
};

const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword, status) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`
  );
};

const filterManureAutocomplete = (keyword) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`
  );
};

const RuleService = {
  getRulesList,
  updateRules,
  getRuleModules,
  createRule,
  getActiveRoles,
  getUserCreation,
  createUserManagement,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateUserManagement,
  deleteManure,
  searchManureDataFull,
  filterManure,
  filterManureAutocomplete,
};
export default RuleService;
